import React from 'react';
import PropTypes from 'prop-types';

import Widget from '../../models/widget';
import StepModel from '../../models/stepModel';

import StepContainer from './stepContainer';
import Loading from '../../components/loading';
import { Menu, Grid } from 'semantic-ui-react';
import { WeezHeader } from '@weezevent/nacre';
import { Link, Route, useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function StepsMenu({ steps, selectedStep, onStepSelected }) {
    return (
        <Menu vertical>
            {steps.map(step => (
                <Menu.Item key={step.id} name={step.id} active={step.id === selectedStep} onClick={() => onStepSelected(step)}>
                    {step.slug}
                </Menu.Item>
            ))}
        </Menu>
    );
}

StepsMenu.propTypes = {
    steps: PropTypes.array,
    selectedStep: PropTypes.number,
    onStepSelected: PropTypes.func.isRequired
};

export default function StepsList({ widgetId = null, organizationId }) {
    const { t } = useTranslation();
    const [steps, setSteps] = React.useState([]);
    const [widget, setWidget] = React.useState(null);
    const [selectedStep, setSelected] = React.useState(null);

    const history = useHistory();

    React.useEffect(() => {
        let widget_promise = Widget.get({
            organizationId,
            id: widgetId
        });

        let steps_promise = StepModel.getAll({
            widgetId,
            organizationId
        });
        Promise.all([widget_promise, steps_promise])
            .then(([widget, steps]) => {
                setWidget(widget);
                setSteps(steps);
            })
            .catch(e => {})
            .finally(() => {});
    }, []);

    const route = `/ticket/O${organizationId}/widgets/${widgetId}`;

    if (!steps.length) {
        return <Loading />;
    }

    return (
        <div>
            <WeezHeader backLink={{ as: Link, to: route }} title={t('ticket.widget.widgetStep')} />
            <Grid relaxed stackable>
                {steps.length && (
                    <Grid.Column width={3}>
                        <StepsMenu
                            steps={steps}
                            selectedStep={selectedStep}
                            onStepSelected={step => {
                                history.push(`${route}/steps/${step.id}`);
                            }}
                        />
                    </Grid.Column>
                )}
                <Grid.Column width={13}>
                    <Route
                        exact
                        path={`${route}/steps/:stepId`}
                        render={({ match: { params } }) => {
                            setSelected(+params.stepId);
                            return <StepContainer organizationId={organizationId} widget={widget} widgetId={widgetId} stepId={params.stepId} steps={steps} />;
                        }}
                    />
                </Grid.Column>
            </Grid>
        </div>
    );
}

StepsList.propTypes = {
    widgetId: PropTypes.number,
    organizationId: PropTypes.number
};
